import Divider from 'antd/lib/divider';
import Space from 'antd/lib/space';
import Tag from 'antd/lib/tag';
import Link from 'antd/lib/typography/Link';
import Text from 'antd/lib/typography/Text';
import Tooltip from 'antd/lib/tooltip';
import * as React from 'react';
import { tagColorForStatusCategory } from '../../helpers';
import { FeatureItem, TicketEpic, TicketStatusCategory } from '../../types';
import { antGrey, tagStyle } from '../styles/globalStyles';
import { shortLabelForTicketItem } from './GroupedPeople';

// Rolls the underlying items of an epic group up into one tag. Done only when every item is done
// (tickets and code). Otherwise the color follows the children's ticket statuses, taking the most
// advanced one: any in-progress or done ticket reads as yellow "Pending", all to-do reads as grey
// "Not done".
export const epicGroupStatus = (items: FeatureItem[]): { label: string; category: TicketStatusCategory } => {
    if (items.length > 0 && items.every((item) => item.isItemDone)) {
        return { label: 'Done', category: TicketStatusCategory.Done };
    }
    const anyTicketStarted = items.some(
        (item) =>
            item.ticket?.statusCategory === TicketStatusCategory.InProgress ||
            item.ticket?.statusCategory === TicketStatusCategory.Done,
    );
    return anyTicketStarted ?
            { label: 'Pending', category: TicketStatusCategory.InProgress }
        :   { label: 'Not done', category: TicketStatusCategory.Todo };
};

export const EpicGroupStatusTag: React.FC<{ items: FeatureItem[]; style?: React.CSSProperties }> = ({
    items,
    style,
}) => {
    const { label, category } = epicGroupStatus(items);
    return (
        <Tag color={tagColorForStatusCategory(category)} style={{ ...tagStyle, fontSize: 10, ...style }}>
            {label}
        </Tag>
    );
};

interface EpicStatusProps {
    epic: TicketEpic;
    ticketItems: FeatureItem[];
    items: FeatureItem[];
}

// Left column of a card in the "Group by epic" lens; mirrors TicketStatus's "key | project" row
const EpicStatus: React.FC<EpicStatusProps> = ({ epic, ticketItems, items }) => {
    const ticketCount = ticketItems.length;
    return (
        <Space direction="vertical" size={10} style={{ width: '100%' }}>
            <EpicGroupStatusTag items={items} />
            <Space
                align="center"
                split={
                    <Divider
                        type="vertical"
                        style={{ backgroundColor: antGrey.grey5, marginLeft: 2, marginRight: 2, height: '75%' }}
                    />
                }
                style={{ alignItems: 'stretch', width: '100%' }}
                className="space-code-ticket-status"
            >
                <Text ellipsis strong style={{ minWidth: 0 }}>
                    {epic.noun}:{' '}
                    <Link
                        href={epic.url}
                        target="_blank"
                        onClick={(e) => e.stopPropagation()} //stop drawer from opening
                        strong
                    >
                        {epic.title}
                    </Link>
                </Text>
                <Tooltip title={ticketItems.map(shortLabelForTicketItem).join(', ')} placement="right">
                    <Text style={{ whiteSpace: 'nowrap' }}>
                        {ticketCount} {ticketCount === 1 ? 'ticket' : 'tickets'}
                    </Text>
                </Tooltip>
            </Space>
        </Space>
    );
};

export default EpicStatus;
